import React from "react";
import "./faq.css";
import styled from "styled-components";
import { client } from "../chat/client";

// const Styledh2 = styled.h2`
//   color: #65cdf0;
// `;
const Styledh3 = styled.h3`
  color: #65cdf0;
`;

// export const Qanda = () => {
//   return (
//     <div>
//       <div className='container FAQ'>
//         <h2 className='breadcrumb'>    General FAQ's</h2>
//         <div className='container '>
//           <div className='questions'>
//             <Styledh3>Q. What is the role of Connection Aid?</Styledh3>
//           </div>
//           <p>
//             Connection-Aid is an online application that is aiming to provide a
//             web-based solution in navigating the course of de-addiction
//             treatment by bringing together dependents, family members, and
//             expert help (rehabs, psychologists, counsellors). Connection-Aid is
//             offering a one-stop solution for all de-addiction related queries,
//             and are goal is to provide educative content so that users can make
//             an informed choice on their next step. We are here to create a
//             community of people built around providing support and guidance
//             towards recovery.
//           </p>
//           <div className='questions'>
//             <Styledh3>
//               Q. What is the difference between social drinking and alcohol
//               abuse?
//             </Styledh3>
//           </div>
//           <p>
//             Casual drinking, or social drinking, is a pattern of low-risk
//             drinking that involves consuming alcohol in low doses occasionally.
//             Social drinkers, according to the NIAAA, US, typically consume
//             alcohol no more than 7 drinks per week ( less than 3 per sitting)
//             for females and no more than 14 drinks per week (less than 4 per
//             sitting) for males. The range may vary across different contexts,
//             however, the basic idea behind the pattern assumes that the
//             individual has sufficient control over drinking behaviour.
//             <br />
//             Alcohol abuse refers to dysfunctional pattern of alcohol use that
//             can lead to clinically significant impairment or distress. This can
//             mean that school or job performance may get affected, childcare and
//             household responsibilities may be neglected, and alcohol-related
//             absences may occur at the workplace. Use of alcohol during
//             situations of physical hazard (drunk driving, operating heavy
//             machinery) and legal difficulties may also arise due to alcohol
//             abuse. Lastly, individuals with alcohol abuse may continue
//             consumption despite being aware of the social or interpersonal
//             problems they may face.
//           </p>
//           <div className='questions'>
//             <Styledh3>
//               Q. What are relevant sources for statistics on drug usage and
//               overuse?
//             </Styledh3>
//           </div>
//           <p>
//             Recently published studies from the Ministry of Social Justice and
//             Empowerment on the ‘Magnitude of Substance Use In India’ (2019)
//             provides a comprehensive overview of the usage of various substances
//             and people affected by substance-use disorders. It assessed the
//             extent and pattern of substance use in each part of the country and
//             estimates harmful use and dependence for 8 substance categories.
//             Find the full report here -{" "}
//             <a href='http://socialjustice.nic.in/writereaddata/UploadFile/Magnitude_Substance_Use_India_REPORT.pdf' />
//           </p>
//           <div className='questions'>
//             <Styledh3>Q. Is there a cure for addiction?</Styledh3>
//           </div>
//           <p>
//             Addiction is curable. The development of addiction depends on the
//             interaction of agent, host and environment. The progression from use
//             to abuse to addiction is determined by this interaction. An
//             understanding of addiction requires addressing all three of these
//             classes of variables. Detoxification, psychological counselling,
//             family counselling, support group therapy are ways to cure
//             addiction. Motivation is a paramount factor in bringing an addict to
//             the doorstep of a treatment.

  

export const Qanda = (props) => {
  console.log(props);
  

  return (
    <div>
      <div className="contianer"> 
        
      <div className='container FAQ'>
        <h2 className='breadcrumb' id="general">General FAQ's</h2>
      
          <div className='questions'>
            <Styledh3>What is the role of Connection Aid?</Styledh3>
          </div>
          <p>
            Connection-Aid is an online application that is aiming to provide a
            web-based solution in navigating the course of de-addiction
            treatment by bringing together dependents, family members, and
            expert help (rehabs, psychologists, counsellors). Connection-Aid is
            offering a one-stop solution for all de-addiction related queries,
            and are goal is to provide educative content so that users can make
            an informed choice on their next step. We are here to create a
            community of people built around providing support and guidance
            towards recovery.
          </p>
          <div className='questions'>
            <Styledh3>
              What are relevant sources for statistics on drug usage and
              overuse?
            </Styledh3>
          </div>
          <p>
            Recently published studies from the Ministry of Social Justice and
            Empowerment on the ‘Magnitude of Substance Use In India’ (2019)
            provides a comprehensive overview of the usage of various substances
            and people affected by substance-use disorders. It assessed the
            extent and pattern of substance use in each part of the country and
            estimates harmful use and dependence for 8 substance categories.
            Find the full report here -{" "}
            {/* <a href='http://socialjustice.nic.in/writereaddata/UploadFile/Magnitude_Substance_Use_India_REPORT.pdf' /> */}
          </p>
          <p>http://socialjustice.nic.in/writereaddata/UploadFile/Magnitude_Substance_Use_India_REPORT.pdf 
        </p>
          <div className='questions'>
            <Styledh3>What drugs commonly cause problems and how do they affect the body?</Styledh3>
          </div>
          <p>
          A complex condition, addiction is understood as compulsive substance use despite harmful consequences. Such repeated and copious drug use challenges self control which makes it difficult to resist urges to take drugs. Addiction, or Substance-Use Disorder (SUD) can cause distorted thinking and behaviour and have drastic physical effects. This can cause impairment in judgement, decision-making, learning and memory. 
          </p>
          <h4>Effects of Drug Use</h4>

          <p>Drug use can lead to several drastic physical, behavioural, and mental changes. While each substance reacts with the body and mind in a different way, there are certain effects that can be considered to be common occurrences across all drugs.</p>

          <p>Physical Effects include:</p>
          <ul>
            <li>Weakened immune system which increases the risk of illnesses and infections</li>
            <li>Heart conditions such as heart attacks, abnormal heart rates, blood vessel infections</li>
            <li>Nausea and abdominal pains that can cause changes in appetite and weight loss </li>
            <li>Increased strain on liver which heightens risk of liver damage</li>
            <li>Lung diseases</li>
            <li>Risk of developing viral infections like HIV/AIDS, Hepatitis</li>
            <li>Other effects such as problems in memory, attention, and decision-making are also common. Repeated drug use can lead to severe mental health problems. Behavioural changes such as paranoia, aggressiveness, hallucinations, impaired judgement, and loss of self control may also develop.</li>
          </ul>

          <div className='questions'>
            <Styledh3>What properties in drugs make them addicting?</Styledh3>
          </div>
          <p>
          Drugs act on the brain’s reward system, changing the way you feel, act and behave as you become more dependent on the substance. All drugs react in different ways, but the ultimate result is that the experience of using the substance is pleasurable, relaxing or energizing, which makes you want to repeat the experience again and again. Over time, your brain and body get used to the response, and you need more quantity of the drug to achieve the same effects. By this time, you may display addictive behaviours such as compulsive seeking, continued drug use despite harmful consequences, lying or stealing to get the substance, and taking dangerous risks for drug use.
          </p>


          <div className='questions'>
            <Styledh3>What is the difference between social drinking and alcohol abuse?</Styledh3>
          </div>
          <p>
          Casual drinking, or social drinking, is a pattern of low-risk drinking that involves consuming alcohol in low doses occasionally. Social drinkers, according to the NIAAA, US, typically consume alcohol no more than 7 drinks per week ( less than 3 per sitting) for females and no more than 14 drinks per week (less than 4 per sitting) for males. The range may vary across different contexts, however, the basic idea behind the pattern assumes that the individual has sufficient control over drinking behaviour. 
          </p>
          <p>
          Alcohol abuse refers to dysfunctional pattern of alcohol use that can lead to clinically significant impairment or distress. This can mean that school or job performance may get affected, childcare and household responsibilities may be neglected, and alcohol-related absences may occur at the workplace. Use of alcohol during situations of physical hazard (drunk driving, operating heavy machinery) and legal difficulties may also arise due to alcohol abuse. Lastly, individuals with alcohol abuse may continue consumption despite being aware of the social or interpersonal problems they may face.
          </p>
          <div className='questions'>
            <Styledh3>Can a person overdose on alcohol? What is alcohol poisoning?</Styledh3>
          </div>

         <p>
         An alcohol overdose occurs when there is so much alcohol in the bloodstream that areas of the brain controlling basic life-support functions—such as breathing, heart rate, and temperature control—begin to shut down. Symptoms of alcohol overdose include-
         </p>

        <ul>
          <li>mental confusion, </li>
          <li>difficulty remaining conscious,</li>
          <li>vomiting,</li>
          <li>seizures,</li>
          <li>trouble breathing,</li>
          <li>slow heart rate,</li>
          <li>clammy skin,</li>
          <li>dulled responses such as no gag reflex (which prevents choking),</li>
          <li>extremely low body temperature.</li>
        </ul>

        <p>Alcohol overdose can lead to permanent brain damage or death.</p>
    
      <p>Alcohol use along with other drugs can increase your risk of an overdose. Using alcohol with opioid pain relievers such as oxycodone and morphine or illicit opioids such as heroin is also a very dangerous combination. Like alcohol, these drugs suppress areas in the brain that control vital functions such as breathing. Ingesting alcohol and other drugs together intensifies their individual effects and could produce an overdose with even moderate amounts of alcohol.</p>
          
      <div className='questions'>
            <Styledh3>What are the effects of drug use during pregnancy?</Styledh3>
          </div>

        <p>
        Use of drugs during pregnancy can harm the fetus, and can lead to birth defects. Drugs taken during pregnancy reach the fetus primarily by crossing the placenta- the same route is used for oxygen and nutrients which are needed for the growth and development of the fetus. They can affect the fetus in several ways-
        </p>
       
       <ul>
         <li>Abnormal development leading to birth defects</li>
         <li>Reducing supply of oxygen and nutrients to fetus, that can lead to underweight and underdeveloped baby</li>
         <li>Premature labour and delivery</li>
         <li>They can also affect the fetus indirectly. For example, drugs that lower the mother's blood pressure may reduce blood flow to the placenta and thus reduce the supply of oxygen and nutrients to the fetus.</li>
         
       </ul>

       <div className='questions'>
            <Styledh3>What are the impacts of medical marijuana on an individual? When is it prescribed? Is it legal?</Styledh3>
          </div>

          <p>
          Medical marijuana is illegal in India and currently, it is not prescribed medically. However, other precedents around the world show limited research in certain properties of marijuana that can act as pain relievers. It claims to relieve nerve pain, acts as a muscle relaxant, and managing nausea.
          </p>

        <div className='questions'>
            <Styledh3>Is there a difference between medical and recreational cannabis?</Styledh3>
          </div>

        <p>
        The difference lies in the THC and CBD components present in medical and recreational cannabis. Medical marijuana contains higher levels of CBD and individuals do not experience the “high” that is associated with the recreational type. Recreational marijuana has higher levels of THC which lead to “high”.
        </p>

        <div className='questions'>
            <Styledh3>Does smoking weed damage your lungs?</Styledh3>
          </div>

        <p>
        Marijuana smoke irritates the lungs, and people who smoke marijuana frequently can have the same breathing problems as those who smoke tobacco. These problems include daily cough and phlegm, more frequent lung illness, and a higher risk of lung infections. Researchers so far haven't found a higher risk for lung cancer in people who smoke marijuana.
        </p>

        <div className='questions'>
            <Styledh3>What are the impacts of cannabis on the brain?</Styledh3>
          </div>

        <p>
        Marijuana exposure during development can cause long-term or possibly permanent adverse changes in the brain. Marijuana use can cause functional impairment in cognitive abilities depending on duration and intensity of use. It has its strongest long-term impact on young people whose brains are still busy building new connections and maturing in other ways.
        </p>

        <div className='questions'>
            <Styledh3>Is it possible for someone to become addicted to a prescribed drug?</Styledh3>
          </div>

          <p>
          The foremost sign of abusing prescription medicines is taking them without medical direction, or in patterns different than what the doctor prescribed. Taking these recreationally, or taking someone else’s prescription are examples. Other warning signs include-
          </p>

          <ul>
            <li>Secretive behavior</li>
            <li>Mood swings</li>
            <li>Decreased social activity or work productivity</li>
            <li>Periods of depression or apathy</li>
            <li>Withdrawal symptoms when not using depressants</li>
          </ul>

        <p>
        Excessive consumption of prescribed drugs can lead to overdose and death. These risks can be dangerously compounded if they are mixed with alcohol, or other illicit drugs.
        </p>

        <div className='questions'>
            <Styledh3>Can addiction be inherited?</Styledh3>
          </div>

          <p>
          Several studies suggest that there is a link between an individual’s genetic characteristics and addiction. Heredity can indicate half the risk of developing addiction. The way a substance affects the physiology as well as the intensity of an individual’s response can depend on their genetic makeup.
          </p>

          <div className='questions'>
            <Styledh3>Can someone have an addictive personality?</Styledh3>
          </div>

          <p>
          Factors related to genetics and environment can make someone more likely to develop the problem of addiction. Individuals with substance-use disorders are prone to experience anxiety, low moods, low motivation and enthusiasm and show limited constraint.  However, the idea that certain traits may somehow make a person ‘more likely’ to develop addiction does not carry scientific merit. Association between traits and addiction is not a cause-effect relation, and cannot be taken to be predictive. 
          </p>

        <div className='questions'>
            <Styledh3>What does the term ‘dependent’ refer to?</Styledh3>
          </div>

        <p>
        Substance Dependence comprises of behavioural and physical symptoms indicating that an individual continues to use drugs despite substance-related problems. Dependents showcase patterns of repeated self administration that result in tolerance, withdrawal and compulsive drug use. They are also likely to experience cravings to use the substance.
        </p>

        <div className='questions'>
            <Styledh3>Can an alcoholic be functional/operational in a workplace setting?</Styledh3>
          </div>

        <p>
        Certain individuals are considered ‘high functioning’ addicts when they are able to continue normal operations in a workplace. However, experts argue that while many people with substance-use disorder may continue to perform at work, they are at a higher risk of physical and psychological harm. Looking at functionality only through the lens of workplace neglects the toll taken on people’s families. It also increases the risk of occupational injuries and lowers the quality of work. As such, functionality at workplace should not be mistaken for a healthy lifestyle.
        </p>

        <div className='questions'>
            <Styledh3>Can mental health issues trigger addiction? Can they make an individual use drugs?</Styledh3>
          </div>

          <p>
          Substance-use disorders (SUDs) are often diagnosed with mental disorders, or vice versa. Research suggests that people with SUDs have higher rates of co-occurring mental illnesses. There is also an increased rate of comorbid SUDs and anxiety disorders. Although co-occurring, it is usually unclear whether mental illness causes SUDs or if common risk factors contribute to both problems.
          </p>

        <div className='questions'>
            <Styledh3>What are visible signs that can help to identify if someone is using drugs?</Styledh3>
          </div>

          <p>
          When a person starts intaking drugs, the effects manifest themselves into behavioural and physical changes. 
Some physical signs that can help identify if someone is using drugs include-
          </p>

          <ul>
            <li>Bloodshot or glazed eyes</li>
            <li>Dilated or constricted pupils</li>
            <li>Abrupt weight changes</li>
            <li>Disturbances in sleep patterns (too much or too little)</li>
            <li>Poor physical coordination</li>
            <li>Unusual body odours</li>
          </ul>

          <p>Behavioural signs that can help identify drug use include-</p>

          <ul>
            <li>Increased aggression, irritability</li>
            <li>Lethargy- lack of energy</li>
            <li>Depression</li>
            <li>Inconsistent behaviour</li>
            <li>Involvement in illegal (or criminal) activities</li>
          </ul>

          <div className='questions'>
            <Styledh3>What are some of the common side-effects of abusing drugs?</Styledh3>
          </div>

          <p>
          Drug use can lead to several drastic physical, behavioural, and mental changes. While each substance reacts with the body and mind in a different way, there are certain effects that can be considered to be common occurrences across all drugs.
          </p>

          <p>Physical effects include- </p>

          <ul>
            <li>Weakened immune system which increases the risk of illnesses and infections</li>
            <li>Heart conditions such as heart attacks, abnormal heart rates, blood vessel infections</li>
            <li>Nausea and abdominal pains that can cause changes in appetite and weight loss</li>
            <li>Increased strain on liver which heightens risk of liver damage</li>
            <li>Seizures, strokes, neural damage, brain damage</li>
            <li>Lung diseases</li>
            <li>Risk of developing viral infections like HIV/AIDS, Hepatitis</li>
            <li>Other effects such as problems in memory, attention, and decision-making are also common. Repeated drug use can lead to severe mental health problems. Behavioural changes such as paranoia, aggressiveness, hallucinations, impaired judgement, and loss of self control may also develop.</li>
          </ul>

          <div className='questions'>
            <Styledh3>Are there other effects of substance-related problems on a person’s lifestyle?</Styledh3>
          </div>

          <p>
          Many studies and reports document the adverse effects of substance-related illnesses on families and individual members. The effects of addiction extend to family in the form of economic and emotional burden, relationship distress, instability, and high rates of tension. Substance-use disorders (SUDs) can also affect a person’s social life in the form of possible criminal behaviours, incarceration, unemployment or other workplace related problems, and transmission of HIV.
          </p>

          <div className='questions'>
            <Styledh3>Are the terms ‘substance abuse’ and ‘substance dependence’ different?</Styledh3>
          </div>

          <p>
          The essential feature of ‘substance abuse’ is that it is a dysfunctional pattern of drug use which takes the form of repeated and significant adverse effects. Substance abuse is accompanied by failure to fulfill obligations at work or school, repeated use in physically hazardous situations, legal problems and recurring social and interpersonal problems.
          </p>

          <p>
          ‘Substance dependence’, on the other hand, also includes tolerance (need of increased amounts of substance to achieve intoxication), withdrawal (behaviour change with physical and mental symptoms when substance is not taken), and patterns of compulsive use.
          </p>

          <div className='questions'>
            <Styledh3>What are the long term effects of addiction on the brain?</Styledh3>
          </div>

          <p>
          Brain scans in addictive behaviours show the impact of drug use on the brain. Compulsive and intensive drug use affects the prefrontal cortex- it affects the brain’s reward system, and also affects self-control, awareness, and pleasure-seeking. Harmful effects to the prefrontal cortex is a major factor in repeated drug use and also accounts for other behaviours that make it difficult to stop taking the substance.
          </p>

          <div className='questions'>
            <Styledh3>I know a dependant and want to help them, but they are unwilling. What can I do about it?</Styledh3>
          </div>

          <p>
          Convincing a dependant to seek treatment when they are unwilling can be a difficult task. While it can be stressful, you should maintain a supportive and communicative approach instead of being accusatory. Educating yourself about the problem can make it easier to reach out to the individual. Read up on the signs and symptoms of addiction, and research on the best treatment options available to you. You can also seek help by chatting with a counsellor.
          </p>

          <div className='questions'>
            <Styledh3>What are the treatment procedures that a dependent goes through during rehab?</Styledh3>
          </div>

          <p>
          Rehabilitation Centres (rehabs) are an extensive programme designed to ensure long-term health. From admission to aftercare, quality de-addiction treatment provides you the details to overcome addiction. As an addict gets his admission in the rehab, a medical and clinical staff assess the patients and their special needs. Questions are asked as to which substance is the patient addicted to and the length of addiction. This helps customize a recovery plan that guides the rehabilitation process further. The next step is detoxification where the body is purged off harmful chemicals. During inpatient care, the patient resides in the facility and receives a number of treatments, therapies, and services that help them recover in both the short and long term.
          </p>

        {/* Alcohol */}
        <h2 className='breadcrumb' id="alcohol">Alcohol</h2>

        
          <div className='questions'>
            <Styledh3>I’ve heard of alcoholism and drug addiction described as a “disease.” Is this true?</Styledh3>
          </div>
          <p>
          Alcoholism and drug addiction have the same fundamental characteristics as physical diseases. They are progressive, meaning that they worsen over time without proper treatment. They are fatal. If untreated, they ultimately lead to death. There is an inherited biological connection that causes a predisposition or increased likelihood of a person having the diseases. They manifests in a predictable way regardless of whom they affect.
          </p>

          <div className='questions'>
            <Styledh3>Once you become addicted, can you be cured?</Styledh3>
          </div>

          <p>
          Since addiction is a relapsing disease, it is not fully treatable. However, with appropriate treatment and intervention, it can be controlled. Those who are alcoholics and/or drug addicted and have been able to stop through an active participation in a plan of recovery consider themselves to be recovering. This means that while they do not currently drink or use drugs they will always be susceptible to alcohol or drugs and will need to make significant lifestyle changes in order to continue to reinforce their new lifestyle.
          </p>

          <p>Addiction has such a profound effect on the individual that even when they no longer use or drink, their previous experiences have left a lasting impact on the way they view themselves and the world around them. Alcoholics and drug addicts don’t consider themselves to be cured, but they do consider themselves to be recovering and “no longer active” in alcohol or drug use.</p>

          <div className='questions'>
            <Styledh3>What is the best way to approach a loved one about their alcohol or drug use?</Styledh3>
          </div>

          <p>
          It is important to approach someone whom you think may have a problem in a way that is non-confrontational. When you are upset with the person as a result of their drinking or use, it is usually not the best time to discuss it with them. Simply convey to them that you care about them and you’ve noticed how their use is affecting their life. Conveying that you would like them to see if they can stop their use, and if they can’t, ask them to get professional help to stop.
          </p>

          <p>
          It is normal for those who abuse alcohol or drugs to react angrily when they are approached even in a gentle, caring manner. Try to avoid a confrontational attitude since by displaying anger- you only help them to focus on something besides their own use. If your initial approach to them does not seem to do any good, then seek out the assistance of close friends and family to help you speak to the person about their use. After your initial approach, don’t hesitate to seek the advice of a qualified professional counsellor.
          </p>

          <div className='questions'>
            <Styledh3>
            What are the medical problems associated with alcohol consumption?</Styledh3>
          </div>

          <p>
          Regular alcohol consumption impacts several organs of the body and causes diseases and problems like-
          </p>

          <ul>
            <li>alcoholism</li>
            <li>polyneuropathy</li>
            <li>myopathy</li>
            <li>cardiomyopathy</li>
            <li>gastritis</li>
            <li>fatty liver disease</li>
            <li>pancreatitis</li>
            <li>alcoholic cirrhosis</li>
            <li>hives</li>
            <li>vertigo</li>
            <li>puts the user at risk of cancer, a stroke, and COPD (Chronic Obstructive Pulmonary Disease)</li>
          </ul>

          <div className='questions'>
            <Styledh3>What are the symptoms of alcohol withdrawal?</Styledh3>
          </div>

          <p>
          Alcohol withdrawal symptoms can occur as early as two hours after the last drink and include-
          </p>

          <ul>
            <li>anxiety</li>
            <li>agitation</li>
            <li>headaches</li>
            <li>shivering</li>
            <li>nausea</li>
            <li>vomiting</li>
            <li>hand tremors</li>
            <li>seizures</li>
            <li>high blood pressure</li>
            <li>hallucinations</li>
            <li>high fever</li>
            <li>rashes</li>
            <li>hot flashes</li>
            <li>and excessive sweating</li>
          </ul>
        
          <div className='questions'>
            <Styledh3>Does alcohol consumption affect fertility?</Styledh3>
          </div>

          <p>
          Heavy alcohol use may diminish ovarian reserve and fertility in women and women trying to get pregnant should be encouraged to minimize alcohol consumption, as even moderate levels could negatively impact their ability to conceive.
          </p>

          <p>
          Alcohol consumption in men can also cause difficulties with fertility and long-term, heavy alcohol use have reported reduced gonadotropin release, testicular atrophy, and decreased testosterone and sperm production.
          </p>

        <div className='questions'>
            <Styledh3>Is there a link between alcohol and bone health?</Styledh3>
          </div>

        <p>
        Excessive alcohol interferes with the balance of calcium, an essential nutrient for healthy bones. Cortisol levels may be elevated in people with alcoholism, which is known to decrease bone formation and increase bone breakdown. Additionally, because of the effects of alcohol on balance, people with alcoholism tend to fall more frequently than those without the disorder. Heavy alcohol consumption has been linked to an increase in the risk of fracture, including the most serious kind—hip fracture. Due to this, alcohol also increases the risk of Osteoporosis.
        </p>

        <div className='questions'>
            <Styledh3>Can alcohol cause UTIs (Urinary Tract Infection)?</Styledh3>
          </div>

          <p>
          While alcohol does not directly cause UTIs, it can raise the risk of getting a UTI, as well as worsen its symptoms. Alcohol use is also associated with other activities that can move bacteria closer to your bladder and cause UTI, like sexual activity. Additionally, the immune system is also weakened, which makes fighting infections more difficult.
          </p>

          <div className='questions'>
            <Styledh3>Can one develop Sudden Onset Alcohol Intolerance?</Styledh3>
          </div> 

          <p>
          Alcohol Intolerance is a genetic condition, in which consuming even less or moderate amounts of alcohol can cause unpleasant sensations like facial flushing, nausea, rapid heartbeat, hypertension, and throbbing headaches.
          </p>

          <p>
          An alcohol intolerance can be developed over time as mostly, older people are on prescription drugs, which on reacting with alcohol, can cause medical implications.
          </p>

          <div className='questions'>
            <Styledh3>Can alcohol (or alcohol withdrawal) trigger a seizure?</Styledh3>
          </div>

          <p>
          Moderate drinking on its own isn’t likely to trigger a seizure, however, if you do have epilepsy and you’re on medication to treat it, consult your doctor about the use of alcohol, because alcohol and anti-seizure medicines may interact with one another. Withdrawal from alcohol and seizures, however, are two things that have a relationship with one another. If you’re dependent on alcohol, you may have a seizure during withdrawal, or you could develop epilepsy.
          </p>

        

        <br />
        <hr />

        {/* Cocaine */}
        <h2 className='breadcrumb' id="cocaine">Cocaine</h2>
       
          <div className='questions'>
            <Styledh3>Q. How is crack different from cocaine?</Styledh3>
          </div>
          <p>
            Cocaine is a psychoactive drug in its powdered form, while crack is
            derived by mixing cocaine with water or baking soda. This gives
            crack cocaine a solid form like rocks. It is called crack due to the
            crackling sound it produces when the drug is heated and smoked. Due
            to its high concentration, it is extremely addictive. Cocaine is
            more expensive while crack is cheaper and is more common among the
            lower socio-economic classes.
          </p>
          <div className='questions'>
            <Styledh3>Q. How do you abuse cocaine?</Styledh3>
          </div>
          <p>
            Due to its highly addictive nature, cocaine abuse can occur commonly
            among those who use the substance. Since cocaine increases dopamine,
            it reinforces drug-taking behaviour that can lead to cocaine abuse
            and dependence. As such, the brain adapts to this excess of dopamine
            and become less sensitive to it which leads to tolerance towards
            cocaine (more needs to be consumed for the same “high”).
          </p>
          <div className='questions'>
            <Styledh3>Q. Are cocaine abusers at risk for HIV/ AIDS?</Styledh3>
          </div>
          <p>
            Studies have shown that cocaine use speeds up HIV infection.
            According to research, cocaine impairs immune cell function and
            promotes reproduction of the HIV virus. Research also suggests that
            people who use cocaine and are infected with HIV may be more
            susceptible to contracting other viruses, such as hepatitis C, a
            virus that affects the liver. Further, using needles increases the
            risk of transmitting HIV.
          </p>

          <div className='questions'>
            <Styledh3>
            Can cocaine abuse lead to withdrawal symptoms?
            </Styledh3>
          </div>
          <p>
          As with other drugs, repeated use of cocaine can lead to addiction. The brain adapts to the changes caused by the drug, and becomes less sensitive to it. As such, people require more stronger and frequent doses to achieve the same “high”. Such intense use of a drug leads to withdrawal (physical and behaviour changes when substance is not taken). Signs of withdrawal include- 
          </p>

          <ul>
            <li>Deprssion</li>
            <li>Fatigue</li>
            <li>Change in appetite</li>
            <li>Unpleasant dreams and insomnia</li>
            <li>Slowed thinking</li>
          </ul>
        
          <div className='questions'>
            <Styledh3>Which treatments work best to overcome cocaine addiction?</Styledh3>
          </div>

          <p>
          Treatments for cocaine addiction begin with medical detoxification in order to purge the body of the substance and its dependency. It may also be necessary for a person to receive certain medicines to treat specific withdrawal symptoms (such as sleep aids in case of sleep disturbance, nutritional supplements in case of malnourishment). Professional support from trusted facilities can further provide de-addiction treatments that make use of motivational incentives, therapy and recovery groups.
          </p>

          <div className='questions'>
            <Styledh3>How does cocaine affect anxiety/depression? </Styledh3>
          </div>

          <p>
          Since cocaine is a stimulant, its use produces chemicals in the brain that can lead to increased energy and activity. However, once the “high” ends, cocaine withdrawal can lead to severe anxiety and depression due to deprivation. Research indicates that anxiety is the leading effect of repeated cocaine use. Further, increased brain activity during substance-use can also lead to severe paranoia and panic attacks.
          </p>

          <div className='questions'>
            <Styledh3>What are the legal policies in the country for possession or intake of cocaine? </Styledh3>
          </div> 

          <p>
          Possession and intake of cocaine is a punishable offense under the NDPS Act and its punishment varies according to the quantity. Small quantity (less than 2 gms) can lead to rigorous punishment upto 6 months or fine upto Rs. 10,000 or both. Quantity between 2 gms and 100 gms can lead to imprisonment upto 10 years + fine upto Rs 1 Lakhs. Commercial Quantity (100 gms and more) can lead to 10-20 years of imprisonment + fine upto Rs 1 to 2 Lakhs.
          </p>

          <p>
          Intake of cocaine can lead to rigorous jail upto 1 year or fine upto Rs. 20,000 or both. Immunity from prosecution can be granted under Section 64A if voluntary rehab treatment is accepted.
          </p>

          <div className='questions'>
            <Styledh3>How do they test for cocaine in the body?</Styledh3>
          </div>

          <p>
          Cocaine drug test, or cocaine screen, can detect signs of the drug by using urine, blood, hair, saliva, or sweat. The test can indicate the presence of cocaine, but also of metabolites of cocaine, which are certain chemicals produced by the body in response to processing cocaine.
          </p>

          <div className='questions'>
            <Styledh3>What are the different signs to look for to see if someone is addicted to cocaine?</Styledh3>
          </div>

          <p>
          Since the “high” produced by cocaine is due to increased dopamine, users may display behaviours such as-
          </p>

          <ul>
            <li>Overly talkative and excitable</li>
            <li>Lowered appetite and need for sleep</li>
            <li>Increased sleep and appetite (once “high” is over)</li>
            <li>White powder residue on the face (in case of snorting)</li>
            <li>Needle marks from injecting</li>
            <li>DIlated pupils, sensitive to light</li>
            <li>Runny nose, frequent nosebleeds</li>
            <li>Increased risk-taking behaviour</li>
            <li>Mood swings</li>

          </ul>


        {/* Cigarette */}
        <br />
        <hr />
        <h2 className='breadcrumb' id="cigarette">Cigarette</h2>
        <div className='questions'>
          <Styledh3>
            Q. What is the difference between ‘light', 'mild' or 'low tar'
            cigarettes?
          </Styledh3>
        </div>
        <p>
          These terms are supposedly used to differentiate the different types
          of cigarettes on the basis of their harmful effects. It is a form of
          marketing strategy. However, several studies indicate that mild, light
          or ultra light cigarettes are not different from the full-flavoured or
          regular cigarettes. There is no such thing as a safe cigarette. All
          tobacco products have cancer-causing element in them.
        </p>
        <div className='questions'>
          <Styledh3>
            Q. How many cigarettes makes an individual an addict?
          </Styledh3>
        </div>
        <p>
          It depends from person to person. Taking large amounts of substances
          or over a longer period of time than it is intended can lead to
          dependence. When a great deal of time is spent on activities necessary
          to obtain or use a substance can also be an indication of dependence
          on cigarettes per se.
        </p>
        <div className='questions'>
          <Styledh3>Q. How long does nicotine stay in the body?</Styledh3>
        </div>
        <p>
          A single standard cigarette has a physiological effect for
          approximately 45 minutes. The nicotine itself has a half life of
          roughly 10 minutes, tapering off in effects just under 20 minutes.
          Nicotine is a water soluble alkaloid. This means that by the time your
          body has gone through a complete filtration cycle through your
          kidneys, you will have excreted the nicotine metabolites. Generally
          withdrawal is at it's worst at the end of day 3.
        </p>
        <div className='questions'>
          <Styledh3>What are the different alternatives to smoking?</Styledh3>
          <p>
          Different alternatives to smoking are e-cigarettes. But alternative tobacco products are attractive to smokers who want to quit smoking. Those who are trying to quit are much more likely to use the alternatives than with smokers with no intent to quit.
          </p>

          <div className='questions'>
            <Styledh3>How much nicotine does a cigarette possess?</Styledh3>
          </div>
          <p>
          The amount of nicotine in each cigarette was from 6.17 to 12.65 mg (1.23 ± 0.15 percent of tobacco weight in each cigarette) in domestic cigarettes. It was between 7.17-28.86 mg (1.80 ± 0.25 percent of tobacco weight in each cigarette) for imported cigarettes, and between 30.08- 50.89 mg (3.82 ± 1.11 percent) for the pipe nicotine.
          </p>

          <div className='questions'>
            <Styledh3>What kinds of activities can I do when I feel the urge to smoke?</Styledh3>
          </div>

          <p>
          Once an individual has planned to quit smoking, a certain personalized quit plan can help the dependent to stay focused, confident and motivated to quick. Having knowledge of the personal triggers and cravings by making some short activities in advance. NRT is the best way to quit smoking by switching to alternative means of nicotine products. NRT can help reduce the withdrawal symptoms.
          </p>

          <div className='questions'>
            <Styledh3>What is a nicotine patch?</Styledh3>
          </div>

          <p>
          Nicotine patch consists of a measured dose of nicotine through the skin. This involves lower- doses of patches over a week. There are various types of patches:</p>
          
          <ul>

          <li>16 hour patch</li>
          <li>24 hour patch</li>

          </ul>

          <div className='questions'>
            <Styledh3>Can nicotine chewing gums make me an addict?</Styledh3>
          </div>

          <p>
          Scheduled dosing helps better. A dosage of 1 to 2 pieces per hour is common. Nicotine gum is usually suggested for 6-12 weeks with the maximum being 6 months. It has some side effects like hiccups, nausea, jaw discomfort, bad taste, throat infection, etc.
          </p>

          <div className='questions'>
            <Styledh3>What is second-hand smoke?</Styledh3>
          </div>

          <p>
          Second-hand smoke/passive smoking happens when someone stands or sits near others who smoke and are hence subjected to second-hand smoke. It is either coming from the burning end of the tobacco product or exhaled by the person who is smoking. 
          </p>

          <div className='questions'>
            <Styledh3>What are the effects of second-hand smoke?</Styledh3>
          </div>

          <p>
          Second-hand smoke can lead to lung cancer and heart disease. It can cause health problems in both adults and children such as cough, phlegm, pneumonia, bronchitis, etc. Children exposed to second-hand smoke are at an increased risk of ear infections, asthma, lung infections, and death from sudden infant death syndrome.
          </p>

          <br />
          <hr />
          <h2 className='breadcrumb' id="LSD"> LSD </h2>
          <div className='questions'>
            <Styledh3>Q. What is a blotting paper?</Styledh3>
          </div>
          <p>
            Drugs that are active as micrograms (one millionth of a gram) such
            as LSD is distributed on a blotting paper. A liquid solution of the
            substance is dropped on the blotting paper. Usually, blotters are
            pierced into single doses (or “hits) and decorated.
          </p>
          <div className='questions'>
            <Styledh3>
              Q. What are the signs to know if a person has consumed LSD?
            </Styledh3>
          </div>
          <p>
            An LSD trip can last for as long as 12 hours and the person may
            experience increased body temperature, heart rate and BP. They may
            not feel tired and may not want to eat. Since the emotional response
            evoked by LSD is so potent, the person may display signs of
            artificial mellowness and relaxation. Other signs include-
          </p>
            <ul>
              <li>Dilated pupils</li>
              <li>Dry mouth</li>
              <li>Panic and paranoia</li>
              <li>Excessive sweating</li>
              <li>Blurred vision</li>
            </ul>
        
          <div className='questions'>
            <Styledh3>Q. Does LSD cause flashbacks?</Styledh3>
          </div>
          <p>
            A long term effect of LSD use is Hallucinogen Persisting Perception
            Disorder (HPPD) which means recurrence of drug-using experience like
            hallucinations in the form of flashbacks. This can occur even after
            significant time has passed from substance intake.
          </p>
          <div className='questions'>
            <Styledh3>Q. How does LSD affect depression and anxiety?</Styledh3>
          </div>
          <p>
            Potentially, some hallucinogens are being studied for possible
            therapeutic benefits in treating mental disorders such as
            depression. However, they may pose serious harm because of the
            profound alteration of perception and mood they cause. Users may do
            things they would never do in real-life, or act on prevailing
            tendencies (like jumping out of a window or off a roof, acting on
            suicidal feelings)
          </p>
        </div>
        <br />
        <hr />
        <h2 className='breadcrumb'>Heroin</h2>
        <div className='questions'>
          <Styledh3>
            Q. Can you become addicted to heroin the first time?
          </Styledh3>
        </div>
        <p>
          Heroin is a powerful opioid that can lead to abuse, dependence, and
          addiction. While it is unlikely that a person will develop an
          addiction to heroin on their first use, a single experience can start
          a cycle of repeated and compulsive use due to its addictive
          properties. The more frequently heroin is used, the quicker one’s
          brain and nervous system adjust to the chemical changes it causes.{" "}
        </p>
        <div className='questions'>
          <Styledh3>Q. How addictive is heroin?</Styledh3>
        </div>
        <p>
          Heroin enters the brain rapidly and binds itself to opioid receptors
          which are involved in feelings of pain and pleasure, and controlling
          heart rate, sleeping and breathing. Long term opioid use can also lead
          to loss in the brain's white matter that can affect decision-making,
          behaviour control, and responses to stress. It is highly addictive,
          and regular users often develop tolerance (need more high and frequent
          doses to get the same “high”). Heroin addiction can have severe
          withdrawal that can begin in a few hours after the drug was last
          taken.
        </p>
        <div className='questions'>
          <Styledh3>Q. How do I know if someone is on heroin?</Styledh3>
        </div>
        <p>
          If you or your loved one is displaying signs of heroin abuse, reaching
          out for help is paramount. The important thing to keep in mind is that
          with proper recovery strategies, addiction is treatable and can be
          managed.
          <br />
          <strong>Signs of heroin use : </strong>
        </p>
          <ul>
            <li>Agitation, drowsiness</li>
            <li>Slurred speech</li>
            <li>Constricted (smaller) pupils</li>
            <li>Memory problems</li>
            <li>Constipation</li>
            <li>
              Changes in behaviour, appearance, decline in personal hygiene
            </li>
          </ul>
        
        <div className='questions'>
          <Styledh3>Q. What is a speedball?</Styledh3>
        </div>
        <p>
          A speedball is a mixture of heroin and cocaine that is typically taken
          by both substances being injected into the bloodstream (they may be
          snorted too). Individuals who speedball claim that the combination
          gives a more intense, long-lasting high. Heroin is an opioid that
          slows breathing and can lead to respiratory failure. Cocaine, on the
          other hand, is a stimulant and has nearly the opposite effect
          (increased heart rate, rapid breathing). A common misconception is
          that the two drugs will balance or cancel each other out. In
          actuality, combining these substances is extremely dangerous due to
          their reaction with each other.
        </p>
        <div className='questions'>
          <Styledh3>
            Q. How does cocaine and heroin work in a speedball?
          </Styledh3>
        </div>
        <p>
          Speedballing is especially risky since is forces the body to process
          different types of drugs at the same time. Taking a depressant
          (heroin) and a stimulant (cocaine) together causes a “push-pull”
          reaction in the body that can be very dangerous. Cocaine uses more
          oxygen in the body while heroin slows breathing- this puts strain on
          overactive lungs and heart, causing confusion in the body.
          Speedballing makes it difficult for the body to receive sufficient
          oxygen needed to balance out the effects of cocaine.
        </p>


        <h2 className='breadcrumb' id="Methamphetamine"> Methamphetamine </h2>

        <div className='questions'>
          <Styledh3>
          How are Amphetamines different as compared to Methamphetamines?
          </Styledh3>
        </div>

        <p>
        Amphetamine is the parent drug of methamphetamine. Both are psychostimulants and have nearly the same chemical structure, but the drugs are not the same. While both can be used for recreational purposes, amphetamines do have some medicinal value and can be legally prescribed by a physician.
        </p>

        <p>
        Alternatively, meth is not prescribed for medical interventions due to its high potential for abuse. The two drugs can have similar effects, but amphetamines are less severe than meth. Even at the same dosages, less amphetamine gets into the brain than meth does.
        </p>

        <div className='questions'><Styledh3>How is methamphetamine different from cocaine?</Styledh3>
        </div>

      <p>
      The chemical structure differs between meth and cocaine, and as such, they work in different ways in the body even though they have the same behavioural and physical effects.
      </p> 

      <p>
      Cocaine is quickly removed and completely metabolized in the body whereas meth has a longer duration of action, and larger percentage remains unchanged- it remains in the brain for longer and has longer effects. Meth also produces high levels of dopamine and as such, smaller quantities produce larger effects. Both drugs are highly addictive and dangerous for consumption.
      </p>

        <h2 className='breadcrumb' id="Amphetamine"> Amphetamine </h2>

        <div className='questions'><Styledh3>What is amphetamine used to treat?</Styledh3>
        </div>

        <p>
        Amphetamines are legal when prescribed by a doctor for conditions like ADHD, but can be abused in varying situations. When used improperly, these drugs can quickly cause intense addiction. If you or someone you love is abusing amphetamines, now is the time to find help.  
        </p>

        <div className='questions'><Styledh3>What are the dangers associated with amphetamine use?</Styledh3></div>
      <p>
      Repeated amphetamine use can have severe effects on brain and bodily functions that may not be immediately noticeable. Its use can be particularly dangerous for persons with heart diseases, high BP, psychiatric problems, people with a history of self-harm and other mental health conditions. Long terms effects include- 
      </p>

      <ul>
        <li>Anxiety</li>
        <li>Malnutrition and weight loss</li>
        <li>Psychosis</li>
        <li>Damage to blood vessels</li>
        <li>Kidney and lung damage</li>
        <li>Stroke</li>
      </ul>

      <div className='questions'><Styledh3>
      What is the “binge and crash” cycle of amphetamine use?
      </Styledh3>
      </div>

      <p>
      The “binge and crash” cycle refers to drug-taking behaviours where an individual takes large doses of a substance repeatedly and thereafter experiences withdrawal. A person abusing stimulant drugs, the category of amphetamines, often uses them in repeated, large doses. This is because the effect of stimulants lasts for short times. This repeated use to prolong their “high” is known as the bingeing. A person may be extremely talkative and energetic during their binge, but may also become paranoid and hostile. Due to intense after-effects of abusing stimulants, bingeing patterns are sustained for longer periods. Users experience anxiety, fatigue, and extreme craving for drug during their crash from amphetamines. 

      </p>
      
      </div>
    </div>


     
     </div>

  );
};

export default Qanda;
